var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloverLeaf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 94,
    viewBox: "0 0 95 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.2001 15.7101C79.4501 9.55009 72.2701 5.85009 66.5501 8.95009L63.9601 10.3601L63.3101 7.49009C61.8401 1.00009 52.7301 -1.94991 46.9701 1.41009C40.8801 4.96009 39.3101 12.7501 40.8701 19.6601L47.1601 47.4301C47.1601 47.4301 72.1601 33.8701 72.1901 33.8501C77.9301 30.7401 83.5001 23.7801 81.2101 15.7101H81.2001Z",
    fill: "url(#paint0_linear_13276_6740)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1102 21.8402C69.0602 18.1502 64.7502 15.9202 61.3202 17.7902L59.7702 18.6302L59.3802 16.9102C58.5002 13.0202 53.0302 11.2502 49.5802 13.2602C42.5402 17.3702 44.6202 26.2702 45.3802 32.9702C45.7402 36.1802 46.1002 39.3902 46.4702 42.6002C46.5202 43.0402 47.3502 47.1102 47.0102 47.3602C52.3702 43.4102 57.8702 39.6602 63.1302 35.5702C67.5002 32.1802 71.8702 27.9902 70.1202 21.8402H70.1102Z",
    fill: "#34B53B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.63,
    d: "M81.2001 15.71C79.4501 9.54995 72.2701 5.84995 66.5501 8.94995L63.9601 10.36L47.0701 47.02L47.1601 47.4199C47.1601 47.4199 72.1601 33.86 72.1901 33.84C77.9301 30.73 83.5001 23.77 81.2101 15.7L81.2001 15.71Z",
    fill: "#A2D3AB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2001 78.1702C14.9501 84.3302 22.1301 88.0302 27.8601 84.9302L30.4501 83.5202L31.1001 86.3902C32.5701 92.8802 41.6801 95.8302 47.4401 92.4702C53.5301 88.9202 55.1001 81.1302 53.5401 74.2202L47.2501 46.4502C47.2501 46.4502 22.2501 60.0102 22.2201 60.0302C16.4801 63.1402 10.9101 70.1002 13.2001 78.1702Z",
    fill: "url(#paint1_linear_13276_6740)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2901 72.04C25.3401 75.74 29.6501 77.96 33.0801 76.09L34.6301 75.25L35.0201 76.97C35.9001 80.86 41.3701 82.63 44.8201 80.62C51.8601 76.51 49.7801 67.61 49.0201 60.91C48.6601 57.7 48.3001 54.49 47.9301 51.28C47.8801 50.84 47.0501 46.77 47.3901 46.52C42.0301 50.47 36.5301 54.22 31.2701 58.31C26.9001 61.7 22.5301 65.89 24.2801 72.04H24.2901Z",
    fill: "#34B53B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.63,
    d: "M13.2001 78.1702C14.9501 84.3302 22.1301 88.0302 27.8601 84.9302L30.4501 83.5202L47.3401 46.8502L47.2501 46.4502C47.2501 46.4502 22.2501 60.0102 22.2201 60.0302C16.4801 63.1402 10.9101 70.1002 13.2001 78.1702Z",
    fill: "#A2D3AB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0102 80.7902C85.1702 79.0402 88.8701 71.8602 85.7701 66.1402L84.3602 63.5502L87.2302 62.9002C93.7202 61.4302 96.6702 52.3202 93.3102 46.5602C89.7602 40.4702 81.9702 38.9002 75.0502 40.4602L47.2802 46.7502C47.2802 46.7502 60.8402 71.7502 60.8602 71.7802C63.9702 77.5202 70.9302 83.0902 79.0002 80.8002L79.0102 80.7902Z",
    fill: "url(#paint2_linear_13276_6740)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8701 69.7002C76.5601 68.6502 78.7901 64.3402 76.9201 60.9102L76.0801 59.3602L77.8001 58.9702C81.6901 58.0902 83.4601 52.6202 81.4501 49.1702C77.3401 42.1302 68.4401 44.2102 61.7401 44.9702C58.5301 45.3302 55.3201 45.6902 52.1101 46.0602C51.6701 46.1102 47.6001 46.9402 47.3501 46.6002C51.3001 51.9602 55.0501 57.4602 59.1401 62.7202C62.5301 67.0902 66.7201 71.4602 72.8701 69.7102V69.7002Z",
    fill: "#34B53B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.63,
    d: "M79.0102 80.7902C85.1702 79.0402 88.8702 71.8602 85.7702 66.1402L84.3602 63.5502L47.7002 46.6602L47.3002 46.7502C47.3002 46.7502 60.8602 71.7502 60.8802 71.7802C63.9902 77.5202 70.9502 83.0902 79.0202 80.8002L79.0102 80.7902Z",
    fill: "#A2D3AB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7101 12.4002C9.5501 14.1502 5.8501 21.3302 8.9501 27.0502L10.3601 29.6402L7.4901 30.2902C0.9901 31.7702 -1.9599 40.8802 1.4001 46.6402C4.9501 52.7302 12.7401 54.3002 19.6601 52.7402L47.4301 46.4502C47.4301 46.4502 33.8701 21.4502 33.8501 21.4202C30.7401 15.6802 23.7801 10.1102 15.7101 12.4002Z",
    fill: "url(#paint3_linear_13276_6740)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8401 23.4902C18.1401 24.5402 15.9201 28.8502 17.7901 32.2802L18.6301 33.8302L16.9101 34.2202C13.0201 35.1002 11.2501 40.5702 13.2601 44.0202C17.3701 51.0602 26.2701 48.9802 32.9701 48.2202C36.1801 47.8602 39.3901 47.5002 42.6001 47.1302C43.0401 47.0802 47.1101 46.2502 47.3601 46.5902C43.4101 41.2302 39.6601 35.7302 35.5701 30.4702C32.1801 26.1002 27.9901 21.7302 21.8401 23.4802V23.4902Z",
    fill: "#34B53B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.63,
    d: "M15.7101 12.4002C9.55007 14.1502 5.85007 21.3302 8.95007 27.0502L10.3601 29.6402L47.0201 46.5302L47.4201 46.4402C47.4201 46.4402 33.8601 21.4402 33.8401 21.4102C30.7301 15.6702 23.7701 10.1002 15.7001 12.3902L15.7101 12.4002Z",
    fill: "#A2D3AB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13276_6740",
    x1: 64.0298,
    y1: 9.70592,
    x2: 48.2837,
    y2: 46.7274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1FF54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#BDF550"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#73D345"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#45BD3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34B53B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13276_6740",
    x1: 29.5384,
    y1: 88.1867,
    x2: 45.0941,
    y2: 45.9407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1FF54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#BDF550"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#73D345"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#45BD3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34B53B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_13276_6740",
    x1: 90.5143,
    y1: 66.2177,
    x2: 40.4488,
    y2: 43.0121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1FF54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#BDF550"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#73D345"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#45BD3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34B53B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_13276_6740",
    x1: 4.66244,
    y1: 27.6171,
    x2: 46.5646,
    y2: 45.0701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1FF54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#BDF550"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#73D345"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#45BD3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34B53B"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloverLeaf);
export default __webpack_public_path__ + "static/media/clover-leaf.272b2694.svg";
export { ForwardRef as ReactComponent };